module.exports = __webpack_public_path__ + "img/titre_lightmode.0ed1608d.webp";